<template>
  <div class="xcard">
    <v-btn small class="mx-4" @click="$router.back()" color="info" rounded outlined> <v-icon>mdi-arrow-left-bold</v-icon> Volver Atras</v-btn>
    <p class="text-center"> <b>Editar Cargo </b> </p>

    <div class="row">
      <div class="col-sm-12">
        <div class="form-group" :class="{'has-error': validation.hasError('cargo.nombre')}">
          <div class="input-group input-group-sm">
            <div class="input-group-addon"><span class="text-danger">*</span> Cargo</div>
            <input type="text" v-model.trim="cargo.nombre" class="form-control" placeholder="Nombre del cargo">
          </div>
          <div class="error" v-if="validation.hasError('cargo.nombre')"> {{validation.firstError('cargo.nombre')}} </div>
        </div>

        <div class="form-group" :class="{'has-error': validation.hasError('cargo.descripcion')}">
          <div class="input-group input-group-sm">
            <div class="input-group-addon"> Descripcion</div>
            <input type="text" v-model.trim="cargo.descripcion" class="form-control" placeholder="Descripcion del cargo">
          </div>
          <div class="error" v-if="validation.hasError('cargo.descripcion')"> {{validation.firstError('cargo.descripcion')}} </div>
        </div>

        <div class="table-responsive">
          <table class="table table-condensed table-hover table-striped">
            <thead>
              <tr>
                <th>Nro</th>
                <th>Visualizar <span class="glyphicon glyphicon-info-sign" title="Si este campo esta seleccionado, pero no tiene ningun permiso, sera omitido"></span> </th>
                <th>Menu</th>
                <th>Permisos</th>
              </tr>
            </thead>

            <tbody>
              <tr v-bind:key="ind" v-for="(m,ind) in menus">
                <td> {{ind+1}} </td>
                <td>
                  <input type="checkbox" v-model="m.visualizar" @click="checkboxPermisoVisualizar(m)">
                </td>
                <td> {{m.nombre}} </td>
                <td>
                  <div class="checkbox" v-bind:key="index" v-for="(p,index) in m.submenus">
                    <label>
                      <input type="checkbox" :checked="p.select" @click="checkboxPermiso(p)"> {{p.nombre}}  <span v-if="p.value" > ({{p.value}}) </span>
                    </label>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <button class="btn btn-azul center-block" @click="validarDatos()"> Guardar Cambios </button>
      </div>
    </div>

    <Alertas ref="alertar" />
    <notifications group="auth" position="bottom right" />
    <notifications group="auth3" position="bottom right" />
  </div>
</template>

<script>
import { Validator } from 'simple-vue-validator';
import Alertas from '@/components/AAlertas.vue'
import {parseJsonError,exito} from '@/components/Utils.js'
import gql from 'graphql-tag'
export default {
  data(){
    return{
      menus:[],
      visus: [true,false],
      cargo: {
        nombre:null,
        descripcion: null,
      }
    }
  },
  validators: {
    'cargo.nombre'(value){ return Validator.value(value).minLength(5).required(); },
    'cargo.descripcion'(value){ return Validator.value(value).minLength(5); },
  },
  components:{Alertas},
  methods:{
    async getDatos(){
      this.$refs.alertar.cargando();
      var sql = gql`query{ getMenus{ id,nombre,submenus{idpadre,id,nombre} } }`;
      await this.$apollo.query({
        query: sql,
      }).then((data) => {
        this.menus = data.data.getMenus;
        this.getCargo();
      }).catch((error) => {
        window.console.error(error)
        this.$notify( parseJsonError( error,'getMenus' ) )
      })
    },
    async getCargo(){
      var sql = gql`query{ getCargo(id:${this.cargo.id}){ id,nombre,descripcion,menuscargo{idmenu,visualizar,value,submenus{id,nombre,idpadre,value}} } }`;
      await this.$apollo.query({
        query: sql,
      }).then((data) => {
        var vue = this;
        var menus = [];
        this.cargo = data.data.getCargo;

        //esta bien falta reaccionar alos eventos click en el check boxde visualizar y de cada menu
        // buscar el menu si tiene ids qutarlo, sino agregarlo, si se que sin ids eliminar el menu
        this.cargo.menuscargo.forEach( function(e){
          var hijo = {};
          var ids = [];
          hijo.padre = e.idmenu;

          var m = vue.menus.find( x => x.id == e.idmenu ); // busca solo los menus devueltos de entre todos los menus, para marcar checbok
          var subs = [];
          var bin = (e.value).toString(2).split('').reverse(); //binario en base 2 invertido
          var exp = 0;
          e.submenus.forEach( function(m){
            subs.push( {id:m.id,nombre:m.nombre,value:m.value,idpadre:m.idpadre,select:false} )
          });
          m.submenus = subs;

          bin.forEach( function(i){
            if( i == "1" ){
                var valor = Math.pow(2,exp);
                var sub = m.submenus.find( x => x.value == valor )
                if( sub != null ) { 
                  sub.select = true;
                  ids.push( sub.id );
                }
            }
            exp++;
          })
          m.visualizar = e.visualizar;
          hijo.visualizar = e.visualizar;
          hijo.ids = ids;
          menus.push( hijo );

        })

        delete this.cargo.menuscargo;
        delete this.cargo.__typename;
        this.cargo.menus = menus;
        //window.console.log( window.stringifyObject(this.cargo) )
        this.$refs.alertar.reset();
      }).catch((error) => {
        window.console.error(error)
        this.$notify( parseJsonError( error,'getCargo' ) )
      })
    },
    checkboxPermiso( p ){
      this.$refs.alertar.reset();
      var menu = this.cargo.menus.find( x => x.padre == p.idpadre );
      if( menu == null ) {
        this.cargo.menus.push( {padre:p.idpadre,visualizar:false,ids:[p.id]} ); 
      }else{
        if( menu.ids == null ) menu.ids = [];
        var contain = menu.ids.find( x => x == p.id )
        if( contain ) {
          for( var i = 0; i < menu.ids.length; i++){ 
            if ( menu.ids[i] === p.id) { menu.ids.splice(i, 1); break; }
          }
        }
        else menu.ids.push( p.id )

        if( menu.ids.length == 0 ){
          for( var j = 0; j < this.cargo.menus.length; j++){ 
            if ( this.cargo.menus[j].padre === p.idpadre) { this.cargo.menus.splice(j, 1); break;}
          }
        }
      }

      //window.console.log( window.stringifyObject( this.cargo.menus ),window.stringifyObject( p ) )
    },
    checkboxPermisoVisualizar( m ){
      var menu = this.cargo.menus.find( x => x.padre == m.id );
      if( menu != null ) {
        menu.visualizar = !m.visualizar;
      }else{
        m.visualizar = false;
      }
      //window.console.log( window.stringifyObject( this.cargo ),"-----\n\n",window.stringifyObject( m ) )
    },

    validarDatos(){
      var obj = window.Object.assign( {},this.cargo );
      // estas acciones van en par, set el objeto para luego limpiar campos nulos
      this.$store.state.obj = obj;
      this.$store.dispatch('quitarNulos');
      delete obj.menuscargo;
      delete obj.__typename;
      
      if( obj.menus == null || obj.menus.length == 0 ){
        this.$refs.alertar.invalido("Debe seleccionar al menus un permiso para este cargo");
        return;
      }

      this.enviarDatos( obj );
    },
    enviarDatos( obj ){
      this.$refs.alertar.cargando();
      var vue = this;
      var sql = gql`mutation{ updateCargo(input:${window.stringifyObject(obj)}){ok,errors{message}} }`;
      // window.console.log('Editarcargo -> enviarDatos -> updateCargo', sql);
      this.$apollo.mutate({
        mutation: sql,
      }).then((data) => {
        if( data.data.updateCargo.ok ){
          vue.$refs.alertar.reset();
          this.$notify( exito( 'Exito','Se han guardado los cambios.' ) );
          this.$router.push({name:'cargos'});
        }else{
          var errores = JSON.stringify(data.data.updateCargo.errors);
          var obj = JSON.parse( errores );
          var vals = '';
          obj.forEach(function(k){ vals += Object.values(k)+"-\n\t"; });
          vue.activo = true;
          vue.$refs.alertar.invalido( vals );
        }
      }).catch((error) => {
        vue.$refs.alertar.invalido();
        this.activo = true;
        this.$notify( parseJsonError( error ) )
        window.console.error(error);
      })

    },
  },
  mounted(){
    var xc = window.sessionStorage.xcargoedit;
    if( xc ){
      var op = JSON.parse( xc );
      if( op ) this.cargo = op;
    }
    this.getDatos();
  }
}
</script>